import { fixedAssets } from 'src/containers/PreCache'
import { COLORS, SIZES } from 'src/styles/theme'
import styled from 'styled-components'

export const StyledLobby = styled.div`
  background: url(${fixedAssets.lobby});
  background-size: 130% 130%;
  background-position: center bottom;
  text-align: center;
  max-height: 100%;
  min-width: 100%;
  min-height: 100vh;
  animation: zoomOut 600ms 700ms forwards;
  
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  .titleImage {
    position: fixed;
    left: 0%;
    opacity: 0;
    transform: translateY(50%);
    animation: flyDownIn 400ms 800ms forwards;
  }
  .visual {
    position: fixed;
    width: 18%;
    cursor: pointer;
  }
  #circle {
    top: 50%;
    left: 50%;
    animation: circleRotate 1700ms forwards;
  }
  #growth {
    top: 20%;
    left: 0%;
    animation: leftFocusIn 500ms 800ms forwards;
    transition: all 200ms ease-in;
    &:hover {
      width: 20%;
    }
  }
  #comfort {
    top: 20%;
    left: 80%;
    animation: rightFocusIn 500ms 800ms forwards;
    transition: all 200ms ease-in;
    &:hover {
      width: 20%;
    }
  }
  #cognition {
    top: 60%;
    left: 80%;
    animation: rightFocusIn 500ms 800ms forwards;
    transition: all 200ms ease-in;
    &:hover {
      width: 20%;
    }
  }
 
  ${SIZES.mobile} {
    .mobile-show {
      display: block;
    }
    .visual {
      width: 30%;
    }
  }
`
